import classes from "./ProductCardSkeleton.module.css";

export default function ProductCardSkeleton({ count = 8 }) {
  return (
    <div className={classes.skeletonGrid}>
      {Array.from({ length: count }).map((_, idx) => (
        <div key={idx} className={classes.skeletonCard}>
          <div className={classes.imageSkeleton}></div>

          <div className={classes.contentSkeleton}>
            <div className={classes.titleSkeleton}></div>
            <div className={classes.skuSkeleton}></div>
            <div className={classes.priceSkeleton}></div>
            <div className={classes.buttonSkeleton}></div>
          </div>
        </div>
      ))}
    </div>
  );
}
